// eslint-disable-next-line jira/restricted/react
import React, { type ComponentType, PureComponent } from 'react';
import { FormattedMessage } from '@atlassian/jira-intl';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';
import { MAX_AUTOMATION_RULES_PER_SD } from '@atlassian/jira-servicedesk-common/src/ui/components/limit-data';
import {
	ATLASSIAN_SUPPORT_URL,
	type Props as LimitMessageProps,
} from '@atlassian/jira-servicedesk-common/src/ui/components/limit-message';
import messages from './messages';
import { MessageContainer } from './styled';

export type Props = {
	numRules: number;
	LimitMessageComponent: ComponentType<Partial<LimitMessageProps>>;
	onContactSupportClicked: () => void;
	onMessageRendered: () => void;
	intl: IntlShape;
};

// eslint-disable-next-line jira/react/no-class-components
class RuleLimitMessage extends PureComponent<Props> {
	renderNearLimitMessage = (limit: number) => {
		const {
			intl: { formatMessage },
			numRules,
		} = this.props;
		const remaining = limit - numRules;
		return formatMessage(messages.nearLimitMessage, { remaining });
	};

	renderAtLimitMessage = (limit: number) => {
		const {
			intl: { formatMessage },
		} = this.props;
		return formatMessage(messages.atLimitMessage, { limit });
	};

	renderOverLimitMessage = (limit: number) => {
		const {
			intl: { formatMessage },
			numRules,
		} = this.props;
		return formatMessage(messages.overLimitMessage, { limit, count: numRules });
	};

	renderLimitDescription = (limit: number) => {
		const {
			intl: { formatMessage },
			onContactSupportClicked,
		} = this.props;
		return (
			<>
				<div key={1}>
					<FormattedMessage
						{...messages.limitDescription}
						values={{
							formattedLimit: <b>{formatMessage(messages.countRules, { count: limit })}</b>,
						}}
					/>
				</div>
				<div key={2}>
					<FormattedMessage
						{...messages.deleteOrContactSupport}
						values={{
							contactSupport: (
								<a href={ATLASSIAN_SUPPORT_URL} target="_blank" onClick={onContactSupportClicked}>
									{formatMessage(messages.contactAtlassianSupport)}
								</a>
							),
						}}
					/>
				</div>
			</>
		);
	};

	render() {
		const { numRules, onMessageRendered, LimitMessageComponent } = this.props;
		return (
			<MessageContainer>
				<LimitMessageComponent
					numUsed={numRules}
					limitProperty={MAX_AUTOMATION_RULES_PER_SD}
					onMessageRendered={onMessageRendered}
					renderNearLimitMessage={this.renderNearLimitMessage}
					renderNearLimitDescription={this.renderLimitDescription}
					renderAtLimitMessage={this.renderAtLimitMessage}
					renderAtLimitDescription={this.renderLimitDescription}
					renderOverLimitMessage={this.renderOverLimitMessage}
					renderOverLimitDescription={this.renderLimitDescription}
				/>
			</MessageContainer>
		);
	}
}

export default injectIntl(RuleLimitMessage);
